import i18n from "@/plugins/vuei18n";

export default {
    active: 10,
    inactive: 0,
    list: [
        {
            label: i18n.t('user.status.active'),
            value: 10
        },
        {
            label: i18n.t('user.status.inactive'),
            value: 0
        }
    ],
    translate(value) {
        let status = this.list.find(status => status.value == value)
        return status ? status.label : ""
    }
}
